export interface Vector {
	x: number,
	y: number,
}

export function vSum(...vectors: Vector[]): Vector {
	const sum = {
		x: 0,
		y: 0,
	};
	for (const vector of vectors) {
		sum.x += vector.x;
		sum.y += vector.y;
	}
	return sum;
}

export function vScale(scalar: number, vector: Vector): Vector {
	return {
		x: vector.x * scalar,
		y: vector.y * scalar,
	};
}

export function vLength(vector: Vector): number {
	return Math.sqrt(vector.x ** 2 + vector.y ** 2);
}

export function rad2Deg(radians: number): number {
	return radians / Math.PI * 180;
}

export function deg2Rad(degrees: number): number {
	return degrees / 180 * Math.PI;
}
